import { render } from "./GalleryCollectionsList.vue?vue&type=template&id=40a60068&scoped=true"
import script from "./GalleryCollectionsList.vue?vue&type=script&lang=js"
export * from "./GalleryCollectionsList.vue?vue&type=script&lang=js"

import "./GalleryCollectionsList.vue?vue&type=style&index=0&id=40a60068&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a60068"]])

export default __exports__